import script from "./partyUploadEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./partyUploadEdit.vue?vue&type=script&setup=true&lang=ts"

import "./partyUploadEdit.vue?vue&type=style&index=0&id=204ed838&scoped=true&lang=scss"
import "./partyUploadEdit.vue?vue&type=style&index=1&id=204ed838&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-204ed838"]])

export default __exports__